const API_URL = process.env.REACT_APP_API_URL || "https://lova-backend-zmd3.onrender.com";

export default API_URL;